import { render, staticRenderFns } from "./FieldInteger.vue?vue&type=template&id=2aff30d2&"
import script from "./FieldInteger.vue?vue&type=script&lang=js&"
export * from "./FieldInteger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports